(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory();
	else
		root["Jsw"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 170);
/******/ })
/************************************************************************/
/******/ ({

/***/ 170:
/* no static exports found */
/* all exports used */
/*!***********************!*\
  !*** ./app/rating.js ***!
  \***********************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var locale = Jsw.Locale.getSection('components.rating');

var VoteDialog = function (_Jsw$Popup) {
    _inherits(VoteDialog, _Jsw$Popup);

    function VoteDialog() {
        _classCallCheck(this, VoteDialog);

        return _possibleConstructorReturn(this, (VoteDialog.__proto__ || Object.getPrototypeOf(VoteDialog)).apply(this, arguments));
    }

    _createClass(VoteDialog, [{
        key: '_initConfiguration',
        value: function _initConfiguration(config) {
            _get(VoteDialog.prototype.__proto__ || Object.getPrototypeOf(VoteDialog.prototype), '_initConfiguration', this).call(this, _extends({
                id: 'rating-dialog',
                title: locale.lmsg('voteTitle'),
                closeButtonEnabled: true,
                hideOnEscape: true,
                content: '' + ('' + ('<p>' + locale.lmsg('voteHint') + '</p>') + '<hr/>' + '<div class="form-box form--vertical">' + '<div class="box-area">' + '<div class="content">' + '<div class="content-area">' + '<div class="nps-survey">' + '<p class="nps-survey__question">') + locale.lmsg('voteQuestion') + '</p>' + '<div class="nps-survey__container">' + '<div id="nps-rating" class="nps-survey__scores"></div>' + '<div class="nps-survey__legend">' + ('<div class="nps-survey__legend-left">' + locale.lmsg('voteLegendBad') + '</div>') + ('<div class="nps-survey__legend-right">' + locale.lmsg('voteLegendGood') + '</div>') + '</div>' + '</div>' + '</div>' + '<hr/>' + '<div class="form-row">' + ('<div class="field-name">' + locale.lmsg('voteLikeHint') + '</div>') + '<div class="field-value"><textarea id="rating-like" class="f-max-size" maxlength="1000"></textarea></div>' + '</div>' + '<div class="form-row">' + ('<div class="field-name">' + locale.lmsg('voteDislikeHint') + '</div>') + '<div class="field-value"><textarea id="rating-dislike" class="f-max-size" maxlength="1000"></textarea></div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>',
                buttons: [{
                    title: locale.lmsg('voteButtonOk'),
                    id: 'rating-vote-button-ok',
                    class: 'action',
                    handler: this.handleVoteButton.bind(this)
                }, {
                    title: locale.lmsg('voteButtonCancel'),
                    id: 'rating-vote-button-cancel',
                    handler: function handler(event, popup) {
                        popup.hide();
                    }
                }]
            }, config));

            this.dialogCause = this._getConfigParam('dialogCause');
            this.supportUrl = this._getConfigParam('supportUrl');
        }
    }, {
        key: '_initComponentElement',
        value: function _initComponentElement() {
            var _this2 = this;

            _get(VoteDialog.prototype.__proto__ || Object.getPrototypeOf(VoteDialog.prototype), '_initComponentElement', this).call(this);

            Jsw.render(this._componentElement.down('#nps-rating'), $R(0, 10).map(function (i) {
                return Jsw.createElement('label', {
                    class: 'nps-survey__score nps-survey__score--' + i,
                    onclick: _this2.checkPossibleSendVote.bind(_this2)
                }, [Jsw.createElement('input', { type: 'radio', name: 'nps-survey-option', value: i }), Jsw.createElement('span', { class: 'nps-survey__score-label' })]);
            }));
        }
    }, {
        key: 'show',
        value: function show() {
            _get(VoteDialog.prototype.__proto__ || Object.getPrototypeOf(VoteDialog.prototype), 'show', this).call(this);
            this.showTime = Date.now();
        }
    }, {
        key: 'hide',
        value: function hide() {
            _get(VoteDialog.prototype.__proto__ || Object.getPrototypeOf(VoteDialog.prototype), 'hide', this).call(this);

            if (this.voted) {
                return;
            }

            if (this.checkPossibleSendVote() || this.getFeedbackLike() || this.getFeedbackDislike()) {
                this.sendVote();
            }

            if (this.dialogCause === 'timeout') {
                this.sendPostpone();
            }
        }
    }, {
        key: 'handleVoteButton',
        value: function handleVoteButton() {
            if (!this.checkPossibleSendVote()) {
                return;
            }

            this.voted = true;
            this.sendVote();
            this.hide();

            new ThankDialog({
                supportUrl: this.supportUrl,
                feedbackLike: this.getFeedbackLike(),
                feedbackDislike: this.getFeedbackDislike()
            });
        }
    }, {
        key: 'checkPossibleSendVote',
        value: function checkPossibleSendVote() {
            var survey = this._componentElement.down('.nps-survey');
            var rate = this.getRate();

            if (rate) {
                var errorField = survey.removeClassName('error').down('.field-errors');
                if (errorField) {
                    errorField.remove();
                }
            } else {
                var _errorField = survey.addClassName('error').down('.field-errors');
                if (!_errorField) {
                    survey.insert('<span class="field-errors">' + ('<span class="error-hint">' + locale.lmsg('voteRequire') + '</span>') + '</span>');
                }
            }

            return rate;
        }
    }, {
        key: 'getRate',
        value: function getRate() {
            return $(this.getId() + '-form')['nps-survey-option'].value;
        }
    }, {
        key: 'getFeedbackLike',
        value: function getFeedbackLike() {
            return this._componentElement.down('#rating-like').value.trim();
        }
    }, {
        key: 'getFeedbackDislike',
        value: function getFeedbackDislike() {
            return this._componentElement.down('#rating-dislike').value.trim();
        }
    }, {
        key: 'sendVote',
        value: function sendVote() {
            new Ajax.Request(Jsw.prepareUrl('/admin/rating/vote'), {
                method: 'post',
                parameters: {
                    voted: this.voted,
                    dialogCause: this.dialogCause,
                    rate: this.getRate(),
                    feedbackLike: this.getFeedbackLike(),
                    feedbackDislike: this.getFeedbackDislike(),
                    dialogDuration: Math.round((Date.now() - this.showTime) / 1000),
                    dialogAtPage: window.location.pathname
                }
            });
        }
    }, {
        key: 'sendPostpone',
        value: function sendPostpone() {
            new Ajax.Request(Jsw.prepareUrl('/admin/rating/postpone'), { method: 'post' });
        }
    }]);

    return VoteDialog;
}(Jsw.Popup);

var ThankDialog = function (_Jsw$Popup2) {
    _inherits(ThankDialog, _Jsw$Popup2);

    function ThankDialog() {
        _classCallCheck(this, ThankDialog);

        return _possibleConstructorReturn(this, (ThankDialog.__proto__ || Object.getPrototypeOf(ThankDialog)).apply(this, arguments));
    }

    _createClass(ThankDialog, [{
        key: '_initConfiguration',
        value: function _initConfiguration(config) {
            var buttons = [{
                title: locale.lmsg('thankButtonClose'),
                class: 'action',
                handler: function handler(event, popup) {
                    popup.hide();
                }
            }];

            var content = '<p>' + locale.lmsg('thankHint') + '</p>';
            if (config.feedbackDislike) {
                var message = locale.lmsg('thankSupportCenter', {
                    link: '<a id="rating-dialog-support-link" href="' + config.supportUrl + '" target="_blank">' + locale.lmsg('supportCenter') + '</a>'
                });
                content += '<p>' + message + '</p>';
            } else if (config.feedbackLike) {
                var introduction = locale.lmsg('introductionText', { message: config.feedbackLike });
                content += '<hr/>' + ('<p>' + locale.lmsg('thankSocialChoose') + '</p>') + ('<textarea id="rating-dialog-share-text" class="f-max-size">' + introduction + '</textarea>') + '<div class="social-links">' + '<a id="rating-dialog-tweet-button" class="twitter-share-button">Tweet</a>' + ('<a id="rating-dialog-close-button"  class="ui-link--muted">' + locale.lmsg('inviteButtonClose') + '</a>') + '</div>';
                buttons = [];
            }

            _get(ThankDialog.prototype.__proto__ || Object.getPrototypeOf(ThankDialog.prototype), '_initConfiguration', this).call(this, _extends({
                title: locale.lmsg('thankTitle'),
                closeButtonEnabled: true,
                hideOnEscape: true,
                content: content,
                buttons: buttons
            }, config));
        }
    }, {
        key: '_addEvents',
        value: function _addEvents() {
            var _this4 = this;

            _get(ThankDialog.prototype.__proto__ || Object.getPrototypeOf(ThankDialog.prototype), '_addEvents', this).call(this);

            if ($('rating-dialog-support-link')) {
                $('rating-dialog-support-link').observe('click', function () {
                    new Ajax.Request(Jsw.prepareUrl('/admin/rating/support-center'), { method: 'post' });
                });
            }
            if ($('rating-dialog-tweet-button')) {
                $('rating-dialog-tweet-button').observe('click', function () {
                    window.open(Jsw.prepareUrl('/admin/rating/social') + '?button=twitter&text=' + encodeURIComponent($('rating-dialog-share-text').value), 'social-share', 'width=600,height=460');
                    _this4.hide();
                });
            }
            if ($('rating-dialog-close-button')) {
                $('rating-dialog-close-button').observe('click', function () {
                    _this4.hide();
                });
            }
        }
    }]);

    return ThankDialog;
}(Jsw.Popup);

module.exports = function (_ref) {
    var buttonId = _ref.buttonId,
        dialogCause = _ref.dialogCause,
        supportUrl = _ref.supportUrl;

    $(buttonId).observe('click', function () {
        new VoteDialog({
            dialogCause: 'manual',
            supportUrl: supportUrl
        });
    });

    if (dialogCause !== 'manual') {
        new VoteDialog({
            dialogCause: dialogCause,
            supportUrl: supportUrl
        });
    }
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/rating.js